import { Point2D } from '../../team-apis/otterdam/answers/shape-typings';
import { ViewRegion } from '../state/view-region-state';
import {
  bottomEditPanelHeight,
  editPanelToolbarHeight,
  rescaleAllToggleHeight,
} from './view-regions.service';

export interface ViewRegionConfiguration {
  isBottomPanel: boolean;
  sceneSize: Point2D;
  readonly: boolean;
  isNewEditPanel: boolean;
}

export function getSideViewRegion({
  isBottomPanel,
  sceneSize,
  readonly,
  isNewEditPanel,
}: ViewRegionConfiguration): Partial<ViewRegion> {
  if (isBottomPanel) {
    const regionSize: Point2D = [sceneSize[0] / 2, bottomEditPanelHeight];
    return { size: regionSize, lowerLeftCorner: [sceneSize[0] / 2, 0] };
  }
  const regionSize = calculateSideEditPanelSize(
    sceneSize,
    readonly,
    isNewEditPanel,
  );
  return { size: regionSize, lowerLeftCorner: [0, 0] };
}

export function getBackViewRegion({
  isBottomPanel,
  sceneSize,
  readonly,
  isNewEditPanel,
}: ViewRegionConfiguration): Partial<ViewRegion> {
  if (isBottomPanel) {
    const regionSize: Point2D = [sceneSize[0] / 2, bottomEditPanelHeight];
    return { size: regionSize, lowerLeftCorner: [0, 0] };
  }
  const regionSize = calculateSideEditPanelSize(
    sceneSize,
    readonly,
    isNewEditPanel,
  );
  return { size: regionSize, lowerLeftCorner: [0, regionSize[1]] };
}

export function getTopViewRegion({
  isBottomPanel,
  sceneSize,
  readonly,
  isNewEditPanel,
  areBottomPanelsHidden = false,
}: ViewRegionConfiguration & {
  areBottomPanelsHidden?: boolean;
}): Partial<ViewRegion> {
  if (isBottomPanel) {
    return {
      size: calculateMainViewSize(areBottomPanelsHidden, sceneSize),
      lowerLeftCorner: calculateMainRegionLowerLeftCorner(
        areBottomPanelsHidden,
      ),
    };
  }
  const regionSize = calculateSideEditPanelSize(
    sceneSize,
    readonly,
    isNewEditPanel,
  );
  return { size: regionSize, lowerLeftCorner: [0, regionSize[1] * 2] };
}

export function calculateMainViewSize(
  areBottomPanelsHidden: boolean,
  sceneSize: Point2D,
): Point2D {
  const mainViewHeight = areBottomPanelsHidden
    ? sceneSize[1]
    : sceneSize[1] - bottomEditPanelHeight - editPanelToolbarHeight;

  return [sceneSize[0], mainViewHeight];
}

export function calculateMainRegionLowerLeftCorner(
  bottomPanelsHidden: boolean,
): Point2D {
  const editPanelAndEditPanelHeight =
    bottomEditPanelHeight + editPanelToolbarHeight;
  return bottomPanelsHidden ? [0, 0] : [0, editPanelAndEditPanelHeight];
}

function calculateSideEditPanelSize(
  canvasSize: Point2D,
  isReadOnly: boolean,
  isNewEditPanel: boolean,
): Point2D {
  let canvasHeight = canvasSize[1];
  if (!isReadOnly) {
    const toolbarHeight = isNewEditPanel
      ? editPanelToolbarHeight
      : rescaleAllToggleHeight;
    canvasHeight -= toolbarHeight;
  } else if (isNewEditPanel) {
    canvasHeight -= editPanelToolbarHeight;
  }

  return [Math.floor(canvasSize[0] / 4), Math.floor(canvasHeight / 3)];
}
